import './src/main.css'
import FlylineChartEnhanced from './src/main.vue'

export default function (Vue) {
  Vue.component(FlylineChartEnhanced.name, FlylineChartEnhanced)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/flylineChartEnhanced/index.js